export default "__VITE_ASSET__DFZMFULZ__"